import React, { useCallback } from "react";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import { snackbarRemove } from "actions/snackbars";
import { cartBulkRemove, cartFetch, cartItemsFetch } from "actions/cart";
import SnackBarItemAddActions from "components/snackbars/snackbar-add-actions";

interface OwnProps {
    id: string;
    brandId: string;
    itemId: string;
}

interface DispatchProps {
    onSnackbarRemove: (id: string) => void;
    onCartBulkRemove: (ids: string[]) => Promise<void>;
    onCartFetch: () => void;
    onCartItemsFetch: () => void;
    onPush: (brandId: string) => void;
}

const InsightsAddAction: React.FC<DispatchProps & OwnProps> = ({
    id,
    brandId,
    itemId,
    onSnackbarRemove,
    onCartBulkRemove,
    onCartFetch,
    onCartItemsFetch,
    onPush,
}) => {
    const handlePrimaryAction = useCallback(() => {
        onSnackbarRemove(id);
        onPush(brandId);
    }, [id, brandId, onSnackbarRemove, onPush]);

    const handleSecondaryAction = useCallback(() => {
        onSnackbarRemove(id);
        onCartBulkRemove([itemId]).then(() => {
            onCartFetch();
            onCartItemsFetch();
        });
    }, [id, itemId, onSnackbarRemove, onCartBulkRemove, onCartFetch, onCartItemsFetch]);

    const handleClose = useCallback(() => {
        onSnackbarRemove(id);
    }, [id, onSnackbarRemove]);

    return (
        <SnackBarItemAddActions
            onPrimaryAction={handlePrimaryAction}
            onSecondaryAction={handleSecondaryAction}
            onClose={handleClose}
        />
    );
};

const mapDispatchToProps = (dispatch) => ({
    onCartFetch: (options) => dispatch(cartFetch(options)),
    onCartBulkRemove: (ids) => dispatch(cartBulkRemove(ids)),
    onCartItemsFetch: () => dispatch(cartItemsFetch()),
    onSnackbarRemove: (id) => dispatch(snackbarRemove(id)),
    onPush: (brandId) => dispatch(push({ pathname: `/brand/${brandId}/cart` })),
});

export default connect<null, DispatchProps, OwnProps>(null, mapDispatchToProps)(InsightsAddAction);
